<p-dialog
  [(visible)]="displayPosition"
  [position]="'center'"
  [closable]="false"
  [modal]="true"
  header="Stock phrases"
  [style]="{ width: '50vw', margin: '0' }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  styleClass="order-dialog">
  <div class="row">
    <div class="header-modal">
      <div class="row">
        <div
          class="d-flex align-items-center justify-content-between gap-2 col-12 mb-3">
          <div class="d-flex align-items-center justify-content-between gap-2">
            <div class="d-flex gap-1 align-items-center">
              <p-radiobutton
                id="all"
                value="all"
                name="stockPhrase"
                [(ngModel)]="stockPhraseCheck"
                (onClick)="getFilterList($event)" />
              <label class="mt-1" for="all">All</label>
            </div>
            <div class="d-flex gap-1 align-items-center">
              <p-radiobutton
                id="customer"
                value="customer"
                name="stockPhrase"
                [(ngModel)]="stockPhraseCheck"
                (onClick)="getFilterList($event)" />
              <label class="mt-1" for="customer">Client</label>
            </div>
            <div class="d-flex gap-1 align-items-center">
              <p-radiobutton
                id="vendor"
                value="vendor"
                name="stockPhrase"
                [(ngModel)]="stockPhraseCheck"
                (onClick)="getFilterList($event)" />
              <label class="mt-1" for="vendor">Vendor</label>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between gap-2">
            <a class="mt-1 delcol" (click)="deleteStockPhrases()"
              ><i class="pi pi-trash"></i> Delete</a
            >
            <a class="mt-1" (click)="showModalDialog()"
              ><i class="pi pi-plus"></i> Add New</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-table
    #dt
    stripedRows
    [rowHover]="true"
    [rows]="20"
    [size]="'small'"
    [value]="filerStockListing"
    selectionMode="multiple"
    styleClass="p-datatable-customers stockListing"
    [rowHover]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    [(selection)]="selectedStock"
    [rowHover]="true"
    styleClass="table-listing"
    dataKey="id">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
        <th class="type">
          Type
          <p-columnFilter
            field="type"
            matchMode="in"
            display="menu"
            [showMatchModes]="false"
            [showOperator]="false"
            [showAddButton]="false">
            <ng-template pTemplate="header">
              <div class="p-px-3 p-pt-3 p-pb-0">
                <!-- <span class="p-text-bold">type Picker</span> -->
              </div>
            </ng-template>
            <ng-template pTemplate="filter" let-filter="filterCallback">
              <p-multiSelect
                [options]="type"
                placeholder="Any"
                (onChange)="filter($event.value)"
                optionLabel="name">
                <ng-template let-option pTemplate="item">
                  <div class="p-multiselect-representative-option">
                    <span class="p-ml-1">{{ option.name }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </th>
        <th class="descp">
          Description
          <p-columnFilter
            type="text"
            field="description"
            display="menu"></p-columnFilter>
        </th>
        <th class="rest" style="width: 150px">
          Restriction
          <p-columnFilter
            field="stockListing"
            matchMode="in"
            display="menu"
            [showMatchModes]="false"
            [showOperator]="false"
            [showAddButton]="false">
            <ng-template pTemplate="header">
              <div class="p-px-3 p-pt-3 p-pb-0">
                <!-- <span class="p-text-bold">visibility Picker</span> -->
              </div>
            </ng-template>
            <ng-template pTemplate="filter" let-filter="filterCallback">
              <p-multiSelect
                [options]="stockListing"
                placeholder="Any"
                (onChange)="filter(getVisiblity($event.value))"
                optionLabel="name">
                <ng-template let-option pTemplate="item">
                  <div class="p-multiselect-representative-option">
                    <span class="p-ml-1">{{
                      getVisiblity(option.visibility)
                    }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </th>
        <th class="notes">
          Notes
          <p-columnFilter
            type="text"
            field="notes"
            display="menu"></p-columnFilter>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-stockListing let-rowIndex="rowIndex">
      <tr class="p-selectable-row">
        <td>
          <p-tableCheckbox [value]="stockListing"></p-tableCheckbox>
        </td>
        <td class="type">{{ getType(stockListing.type) }}</td>
        <td class="descp">{{ stockListing.description }}</td>
        <td class="rest max-width-10">
          {{ getVisiblity(stockListing.visibility) }}
        </td>
        <td class="notes">{{ stockListing.notes }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No quotes found.</td>
      </tr>
    </ng-template>
  </p-table>
  <ng-template pTemplate="footer">
    <div class="d-flex pt-2 gap-3 justify-content-end">
      <!-- <button
        type="button"
        (click)="addFieldData()"
        class="btn btn-primary me-3">
        Add
      </button>
      <button
        type="button"
        (click)="closePositionDialog()"
        class="btn btn-secondary me-3">
        Cancel
      </button> -->

      <p-button label="Add" (click)="addFieldData()" />

      <p-button
        label="Cancel"
        (click)="closePositionDialog()"
        variant="outlined"
        severity="secondary" />
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="displayModal"
  [modal]="false"
  [style]="{ width: '40vw' }"
  [draggable]="false"
  [resizable]="true"
  appendTo="body"
  styleClass="order-dialog">
  <ng-template pTemplate="header">
    <div class="header-modal pb-4 has-border w-100 d-flex align-items-center">
      <h2 class="me-2">Stock phrases</h2>
    </div>
  </ng-template>
  <form [formGroup]="stockPhraseForm">
    <div class="row">
      <div class="col">
        <div class="form-group has-float-label mb-4">
          <label class="form-label" for="type"
            >Type<span class="madatory-field">*</span></label
          >
          <p-select
            formControlName="type"
            [(ngModel)]="defaultType"
            [options]="type"
            optionLabel="name"
            optionValue="id">
          </p-select>
        </div>
      </div>
      <div class="col">
        <div class="form-group has-float-label mb-4">
          <label class="form-label" for="type"
            >restriction <span class="madatory-field">*</span></label
          >
          <p-select
            formControlName="visibility"
            [(ngModel)]="defaultRestriction"
            optionDisabled="status"
            optionValue="id"
            optionLabel="name"
            [options]="visibility">
          </p-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group has-float-label mb-4">
          <label class="form-label" for="descp">Description</label>
          <textarea
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            placeholder=""
            id="descp"
            formControlName="description"></textarea>
        </div>
      </div>
      <div class="col">
        <div class="form-group has-float-label mb-4">
          <label class="form-label" for="notes">Notes</label>
          <textarea
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            placeholder=""
            id="notes"
            formControlName="notes"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col d-flex">
        <div class="form-check d-flex align-items-center p-0 ms-2 gap-2">
          <p-radioButton
            id="cspecific"
            value="vendor"
            name="cspecific"
            [disabled]="vendorCheckbox"
            [(ngModel)]="addStockPhraseCheck"
            [ngModelOptions]="{ standalone: true }"
            (onClick)="getCustomerAndVendorStatus($event)" />
          <label class="form-check-label mt-1" for="cspecific"
            >Vendor specific</label
          >
        </div>
        <div class="form-check d-flex align-items-center p-0 ms-2 gap-2">
          <p-radioButton
            id="vspecific"
            value="customer"
            name="vspecific"
            [disabled]="customerCheckbox"
            [(ngModel)]="addStockPhraseCheck"
            [ngModelOptions]="{ standalone: true }"
            (onClick)="getCustomerAndVendorStatus($event)" />
          <label class="form-check-label mt-1" for="vspecific"
            >Client specific</label
          >
        </div>
        <div class="form-check d-flex align-items-center p-0 ms-2 gap-2">
          <p-radioButton
            id="none"
            value="none"
            name="radio1"
            [(ngModel)]="addStockPhraseCheck"
            [ngModelOptions]="{ standalone: true }"
            (onClick)="getCustomerAndVendorStatus($event)" />
          <label class="form-check-label mt-1" for="none">none</label>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="d-flex pt-2 gap-3 justify-content-end">
      <!-- <button
        type="button"
        (click)="closeModalDialog()"
        class="btn btn-secondary me-3">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="save()"
        [disabled]="!stockPhraseForm.valid">
        Save
      </button> -->

      <p-button
        label="Cancel"
        (click)="closeModalDialog()"
        variant="outlined"
        severity="secondary" />

      <p-button
        label="Save"
        (click)="save()"
        [disabled]="!stockPhraseForm.valid" />
    </div>
  </ng-template>
</p-dialog>
